import {useContext} from 'react';

import {WebsocketsContext} from '../websockets-context';

export const useWebsocketInstance = () => {
    const {wsInstance} = useContext(WebsocketsContext);
    return {wsInstance};
};
